import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-sainik-account',
  templateUrl: './sainik-account.component.html',
  styleUrls: ['./sainik-account.component.css']
})
export class SainikAccountComponent implements OnInit {

  code: any;
  UserId: any;
  data: any;
  user:any={};
    
  constructor(private userService: RegistrationService,private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {
    debugger;
    this.route.params.subscribe(params =>
      this.UserId = params['userId']
    );
    this.route.params.subscribe(params =>
      this.code = params['code']
    );
    this.ConfirmationMail(this.UserId,this.code)
  }
  
 

  ConfirmationMail(userId,code) {
    this.user.userId=userId;
    this.user.code=code;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.ConfirmedMail(this.user);
    this.data.subscribe(
      (response:any) => {
        if(response==true){
        swal('','Email Verified Successfully!','success');
        this.router.navigate(['/login']);
        }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";          
        swal('',error.error.Message);
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/registration/sainik-account/sainik-account.component.ts